<template>
  <div
    class="flex"
    :class="classes"
  >
    <component
      :is="item.name"
      v-for="(item, index) in items"
      v-if="items.length !== 0"
      :key="index"
      v-bind="item.attrs || {}"
      v-on="item.listeners || {}"
    />
    <slot v-if="items.length === 0" />
  </div>
</template>
<script>
import { getComponentNameFn } from '@/utils/componentUtils'

/**
 * @type {import('vue').Component}
 */
const HKLFlex = {
  props: {
    items: {
      type: Array,
      default: () => [],
      validator: (items) => items.every((item) => {
        const attrs = item.attrs || {}
        const listeners = item.listeners || {}
        const checks = [
          typeof item === 'object',
          getComponentNameFn(item.name),
          typeof attrs === 'object' && !Array.isArray(attrs),
          typeof listeners === 'object' && !Array.isArray(listeners),
        ]
        return checks.every(Boolean)
      }),
    },
    direction: {
      type: String,
      default: 'row',
      validator: (direction) => ['row', 'column'].includes(direction),
    },
  },
  setup (props) {
    return {
      classes: [`flex-${props.direction}`],
    }
  },
}

export default HKLFlex

</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  &-row {
    flex-direction: row;
  }
  &-column {
    flex-direction: column;
  }
}
</style>
